module.exports = __webpack_public_path__ + "img/model_42_zh.a371158c.jpg";